import { render, staticRenderFns } from "./ClinicAndProfessionals.html?vue&type=template&id=0e8b386a&external"
import script from "./ClinicAndProfessionals.vue?vue&type=script&lang=js"
export * from "./ClinicAndProfessionals.vue?vue&type=script&lang=js"
import style0 from "./ClinicAndProfessionals.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports